import { Component, inject, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, ArkUnitOfWork, AuthService, SessionInformationService } from '../../core/core.module';
import _ from 'lodash';
import { environment } from 'environments/environment';
import validationEngine from 'devextreme/ui/validation_engine';
import { CommitteeAttachment } from 'app/core/model/entity-model';
import { alert, confirm } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-attachment-dialog',
    templateUrl: './attachment-dialog.component.html',
    styleUrls: ['./attachment-dialog.component.scss'],
    standalone: false,
})
export class AttachmentDialogComponent implements OnInit {
    private sessionInfo = inject(SessionInformationService);
    result: Subject<any> = new Subject<any>();
    fileUploaded = false;
    committeeId: number;
    userName: string;

    attachments: any;
    attachment: CommitteeAttachment;

    processing: boolean = false;
    baseUploadUrl: string = `${environment.serviceName}/api/utility/uploadCommitteeAttachment/`;
    uploadHeaders: any;
    serviceName = environment.serviceName;
    renameOnly: boolean = false;

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, private appInfo: AppInformationService, private auth: AuthService) {}

    async ngOnInit() {
        this.uploadHeaders = { Authorization: 'Bearer ' + this.auth.currentUser.jwtToken };
        this.userName = this.sessionInfo.getItem('memberEmail');
    }

    async save() {
        const result = await this.validate();
        if (!result) return;
        this.processing = true;
        await this.uow.commit();
        this.result.next({ success: true, value: '' });
    }

    async close() {
        if (this.fileUploaded) {
            const result = await confirm(`Are you sure you want to cancel?`, `Graafschap CRC`);
            if (!result) return;
            else if (!this.renameOnly) {
                this.attachment.deleted = new Date();
                this.attachment.deletedBy = this.userName;
                await this.uow.commit();
            }
        }
        this.processing = true;
        this.result.next({ success: false });
    }

    async validate() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result: any | null = validationEngine.validateGroup('mainValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    async uploadStarted(e) {
        this.appInfo.pleaseWaitShow();
    }

    async uploaded(e) {
        if (e && e.request && e.request.responseText) {
            const fileResponses = JSON.parse(e.request.responseText);

            const attachment = await this.uow.committeeAttachments.byId(fileResponses.id);

            // const attachment = this.uow.committeeAttachments.createEntity({
            //     name: fileResponses.name,
            //     filename: fileResponses.link,
            //     created: new Date(),
            //     createdBy: this.auth.currentUser.userName,
            //     committeeId: this.committeeId,
            //     typeId: 2,
            // }) as CommitteeAttachment;

            attachment.createdBy = this.userName;
            this.attachment = attachment;
        }
        await this.uow.commit();
        this.appInfo.pleaseWaitHide();
        this.fileUploaded = true;
    }

    async uploadError(e) {
        await alert('An error occurred while attempting to upload the file(s)', `${this.appInfo.settings.church}`);
        this.appInfo.pleaseWaitHide();
    }
}
